import { Link, useLocation } from 'react-router-dom';
import './Hero.css';
import { Button } from './ui';
import { formatNumber, getFriendlyDate, getFriendlyName, getFriendlyPublicKey, getLinkWithParams } from '../utils';
import { useDevice } from '../hooks';
import { UserProviderValue } from '../models';
import { UserContext } from '../contexts/user.context';
import { useContext, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

export function Hero(props: { title: string }) {
   const { user, balance, logOut } = useContext<UserProviderValue>(UserContext);
   const { title } = props;
   const { isMobile } = useDevice();
   const location = useLocation();

   const isNotRootRoute = location.pathname !== '/';
   const name = useMemo(() => {
      return getFriendlyName(user);
   }, [user]);

   return (
      <div className={`hero flex flex-col  ${isMobile ? 'items-center' : 'justify-between'} gap-3`}>
         {!isMobile ? (
            <div>
               {isNotRootRoute && (
                  <Button
                     type="transparent"
                     to={getLinkWithParams('/')}
                     children={
                        <div className="flex items-center gap-1">
                           <img
                              src="/assets/icons/arrow-back.svg"
                              alt="GolfN"
                              width={8}
                           />
                           <span>Back</span>
                        </div>
                     }></Button>
               )}
            </div>
         ) : (
            user && (
               <div className="flex center">
                  <div className="flex flex-col items-center justify-center gap-2 box bg-gray p-3">
                     <div className="flex flex-col items-center gap-1">
                        <img
                           className="round-image"
                           src={user.image ?? '/assets/icons/user-icon.png'}
                           alt=""
                           width={isMobile ? 35 : 40}
                           height={isMobile ? 35 : 40}
                        />
                        <div className="flex flex-col items-center ">
                           <h3>Welcome{name ? `, ${name}!` : ''}</h3>
                           {user.createdAt && (
                              <span className="small gray">
                                 Member since: <span className="white">{getFriendlyDate(user.createdAt, true)}</span>
                              </span>
                           )}
                        </div>
                     </div>

                     <div className="flex flex-col gap-2">
                        <div className="flex items-center flex-center wrap gap-1">
                           <Link
                              className={`with-bg flex items-center gap-1 `}
                              to={getLinkWithParams('/account')}>
                              <img
                                 src="/assets/icons/email-icon.svg"
                                 alt=""
                                 width={18}
                              />
                              {user.email ?? 'Link Email'}
                           </Link>

                           <Link
                              className={`with-bg flex items-center gap-1`}
                              to={getLinkWithParams('/account')}>
                              <img
                                 src="/assets/icons/wallet-icon.svg"
                                 alt=""
                                 width={18}
                              />
                              {getFriendlyPublicKey(user) || 'Link Wallet'}
                           </Link>
                        </div>
                        <div className="flex justify-center">
                           <Link
                              className=" flex items-center gap-1"
                              to={getLinkWithParams('/')}
                              onClick={logOut}>
                              <img
                                 src="/assets/icons/logout-icon.svg"
                                 alt=""
                                 width={20}
                              />
                              Log Out
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
            )
         )}
         <div className={`flex ${isMobile ? 'center' : 'justify-between'} items-center`}>
            {!isMobile && (
               <div>
                  <h1>{title}</h1>
               </div>
            )}
            {user && (
               <div className="flex end items-center gap-4">
                  <div className="flex items-center">
                     <img
                        className="currency-icon p-2"
                        src="/assets/icons/xp-icon.png"
                        alt=""
                        width={40}
                     />
                     {!balance ? <Skeleton /> : <h2 className="">{formatNumber(balance?.points ?? 0)}</h2>}
                  </div>
                  <div className="flex items-center">
                     <img
                        className="currency-icon p-2"
                        src="/assets/icons/ticket-icon.svg"
                        alt=""
                        width={40}
                     />
                     {!balance ? <Skeleton /> : <h2>{formatNumber(balance?.tickets ?? 0)}</h2>}
                  </div>
               </div>
            )}
         </div>
      </div>
   );
}
